import { createGenericListItemReducer } from "common/genericListItemReducer";
import { DELIVERY_RECEIVED, DELIVERY_REQUESTED, DELIVERY_REQUEST_FAILED } from "./deliveryActions";

export const delivery = createGenericListItemReducer(DELIVERY_REQUESTED, DELIVERY_RECEIVED, DELIVERY_REQUEST_FAILED);
